import { Fragment, useCallback } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { NumeratorsCrumbs } from '../constants';
import FormNumerator, { NumeratorForm } from 'system/components/numerators/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { __OPERATION__MANAGEMENT__ } from 'shell/constants/environment';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { Numerator } from 'shell/models/numerator';

const NumeratorsNewPage = (): React.ReactElement => {
  const { post: insertNumerator } = useHttpFetch(
    `${__OPERATION__MANAGEMENT__}/numeratore/documenti/`
  );
  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues?: NumeratorForm) => {
      const payload: Numerator = {
        key: {
          tipoRegistro: String(formValues?.numeratorRegisterType),
          annoDocumento: Number(formValues?.year),
        },
        descrizioneNumeratore: String(formValues?.description || ''),
        progressivoDocumento: Number(formValues?.currentNumerator),
      };
      insertNumerator({
        ...payload,
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/numeratori');
      });
    },
    [insertNumerator, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...NumeratorsCrumbs, { name: 'Nuovo Numeratore' }]} />
      <FormNumerator
        title="Nuovo Numeratore"
        onOk={onSubmit}
        onCancel={() => {
          navigate('/sistema/numeratori');
        }}
      />
    </Fragment>
  );
};

NumeratorsNewPage.displayName = 'Numerator new page component';

export default NumeratorsNewPage;
